import { cuddlesLogo } from 'assets/images';
import clsx from 'clsx';
import { useMarketplace } from 'hooks/useMarketplace';
import React from 'react';

import classes from './PoweredByCuddles.module.scss';

interface PoweredByCuddlesProps {
    className?: string;
}

export const PoweredByCuddles: React.FC<PoweredByCuddlesProps> = props => {
    const marketplace = useMarketplace();

    return (
        <a
            target="_blank"
            rel="noopener noreferrer"
            className={clsx(classes.root, props.className)}
            href={`https://www.cuddlesapp.com?utm_source=online-booking&utm_medium=${marketplace.name}`}
        >
            Powered by <img src={cuddlesLogo} alt="Cuddles Logo" />
        </a>
    );
};
